import * as Yup from 'yup';

export default Yup.object({
  ptsPlaceID: Yup.number().nullable().required('Select a tower reference'),
});
